import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Typography, Card, Col, Row, Spin, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useParams, useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import BarChart from "../../graph-plots/bar";
import Logo from "../../../../../assets/Logo.png";
import * as taxCollectionActions from "../../../../../actionCreators/TaxCollection";
import "../../reports/reports.css";
import {
  formatUnitsOfProperties,
  formatYearlyTotalAndPaidTax,
  customColorFunction,
  formatLabelFunction,
  tooltipFormatterFunction,
} from "../../../../../utils/reportsUtils";

const ZoneReportPDF = ({
  getYearlyPaidAndTotalTaxOfZone,
  yearlyTotalAndPaidTaxOfZone,
  getYearlyPaidAndPendingUnitsOfZone,
  yearlyPaidAndPendingUnitsOfZone,
  getTotalRegisteredPropertiesOfZone,
  totalRegisteredPropertiesOfZone,
  getTaxOfZone,
  taxOfZone,
  getTopPaidUnitsOfZone,
  topPaidUnitsOfZone,
  getTopDefaultUnitsOfZone,
  topDefaultUnitsOfZone,
  getCircleOrZoneName,
  circleOrZoneName,
}) => {
  const { id } = useParams();
  const history = useHistory();
  const [zone, setZone] = useState(null);
  const [eto, setEto] = useState(null);
  const [district, setDistrict] = useState(null);
  const [totalRegisterProperties, setTotalRegisteredProperties] = useState("-");
  const [totalTax, setTotalTax] = useState("-");
  const [pendingTax, setPendingTax] = useState("-");
  const [paidTax, setPaidTax] = useState("-");
  const [topPaidProperties, setTopPaidProperties] = useState(null);
  const [topDefaultProperties, setTopDefaultProperties] = useState(null);
  const [yearlyPaidAndPendingTaxData, setYearlyPaidAndPendingTaxData] =
    useState([]);
  const [yearlyPaidAndPendingUnits, setYearlyPaidAndPendingUnits] = useState(
    []
  );
  useEffect(() => {
    getCircleOrZoneName({ zone_id: id });
    getYearlyPaidAndTotalTaxOfZone({ zone_id: id });
    getYearlyPaidAndPendingUnitsOfZone({ zone_id: id });
    getTotalRegisteredPropertiesOfZone({ zone_id: id });
    getTaxOfZone({ zone_id: id });
    getTopPaidUnitsOfZone({ zone_id: id });
    getTopDefaultUnitsOfZone({ zone_id: id });
  }, []);
  useEffect(() => {
    setZone(circleOrZoneName?.data[0]?.zone);
    setDistrict(circleOrZoneName?.data[0]?.district);
    setEto(circleOrZoneName?.data?.[1]?.[0]?.user)
  }, [circleOrZoneName.data]);
  useEffect(() => {
    const [data] = formatYearlyTotalAndPaidTax(
      yearlyTotalAndPaidTaxOfZone.data,
      null
    );
    const currentYearPendingTax = data[data?.length - 1]?.tax;
    setPendingTax(currentYearPendingTax);
    setYearlyPaidAndPendingTaxData(data);
  }, [yearlyTotalAndPaidTaxOfZone.data]);
  useEffect(() => {
    const [data] = formatUnitsOfProperties(
      yearlyPaidAndPendingUnitsOfZone.data,
      null
    );
    setYearlyPaidAndPendingUnits(data);
  }, [yearlyPaidAndPendingUnitsOfZone.data]);
  useEffect(() => {
    setTotalRegisteredProperties(
      totalRegisteredPropertiesOfZone?.data?.TotalProperties?.[0]?.total
    );
  }, [totalRegisteredPropertiesOfZone.data]);
  useEffect(() => {
    setTotalTax(taxOfZone?.data?.TaxByZone[0]?.total);
    setPaidTax(taxOfZone?.data?.TaxByZone[0]?.paid);
  }, [taxOfZone.data]);
  useEffect(() => {
    setTopPaidProperties(topPaidUnitsOfZone?.data?.Properties);
  }, [topPaidUnitsOfZone.data]);
  useEffect(() => {
    setTopDefaultProperties(topDefaultUnitsOfZone?.data?.Properties);
  }, [topDefaultUnitsOfZone.data]);
  useEffect(() => {
    setTimeout(function () {
      if (topDefaultUnitsOfZone?.loading && topPaidUnitsOfZone?.loading) {
        const input = document.getElementById("report");
        html2canvas(input).then((canvas) => {
          var imgWidth = 200;
          var pageHeight = 290;
          var imgHeight = (canvas.height * imgWidth) / canvas.width;
          var heightLeft = imgHeight;
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF();
          var position = 0;
          var heightLeft = imgHeight;
          pdf.addImage(imgData, "JPEG", 7, position, imgWidth, imgHeight);
          // pdf.save("download1.pdf");
          window.open(pdf.output("bloburl"), "_blank");
        });
      }
    }, 3000);
  }, [topDefaultUnitsOfZone?.loading, topPaidUnitsOfZone?.loading]);
  return (
    <div>
      <div className="close-button-section">
        <Button
          className="close-button"
          // type="primary"
          onClick={() => {
            history.goBack();
          }}
        >
          <ArrowLeftOutlined />
          <span>Back</span>
        </Button>
      </div>
      <div id="report" style={{ backgroundColor: "white" }}>
        <div className="report-logo">
          <img src={Logo}></img>
          <div className="text-data">Zone Report</div>
        </div>

        <div className="header-details">
          <Typography className="text-label">
            Date :{" "}
            <span className="text-data"> {new Date().toDateString()}</span>
          </Typography>
          <Typography className="text-label">
            District Name :{" "}
            <span className="text-data"> {district ? district : "-"}</span>
          </Typography>
          <Typography className="text-label">
            Zone :<span className="text-data"> {zone && zone}</span>
          </Typography>
          <Typography className="text-label">
            ETO Name :<span className="text-data"> {eto && eto}</span>
          </Typography>
        </div>
        <div className="body">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={8} xl={12}>
              <div className="report-stats">
                <div
                  className="report-stats-container"
                  style={{ border: "1px solid black" }}
                >
                  <Typography className="report-stats-header">
                    Total Registered Properties current fiscal year
                  </Typography>
                  <div className="report-stats-data">
                    {totalRegisterProperties
                      ? parseInt(totalRegisterProperties).toLocaleString()
                      : 0}
                  </div>
                </div>
                <div
                  className="report-stats-container"
                  style={{ border: "1px solid black" }}
                >
                  <Typography className="report-stats-header">
                    Total Demand current fiscal year
                  </Typography>
                  <div className="report-stats-data">
                    PKR {totalTax ? parseInt(totalTax).toLocaleString() : 0}
                  </div>
                </div>
                <div
                  className="report-stats-container"
                  style={{ border: "1px solid black" }}
                >
                  <Typography className="report-stats-header">
                    Pending amount current fiscal Year
                  </Typography>
                  <div className="report-stats-data">
                    PKR {pendingTax ? parseInt(pendingTax).toLocaleString() : 0}
                  </div>
                </div>
                <div
                  className="report-stats-container"
                  style={{ border: "1px solid black" }}
                >
                  <Typography className="report-stats-header">
                    Paid amount current fiscal Year
                  </Typography>
                  <div className="report-stats-data">
                    PKR {paidTax ? parseInt(paidTax).toLocaleString() : 0}
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={8} xl={12}>
              <Card style={{ border: "1px solid black", height: "100%" }}>
                <BarChart
                  data={yearlyPaidAndPendingTaxData}
                  xField="year"
                  yField="tax"
                  xLabel="Fiscal Year"
                  yLabel="Tax (PKR)"
                  customColorFtn={customColorFunction}
                  colorFieldName={"name"}
                  formatLabelFunction={formatLabelFunction}
                  tooltipFormatterFunction={tooltipFormatterFunction}
                  isNoData={!yearlyTotalAndPaidTaxOfZone?.data?.length}
                />
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xs={24} sm={24} md={24} lg={8} xl={24}>
              <Card style={{ border: "1px solid black" }}>
                <BarChart
                  data={yearlyPaidAndPendingUnits}
                  xField="year"
                  yField="units"
                  xLabel="Fiscal Year"
                  yLabel="Units (Properties)"
                  customColorFtn={customColorFunction}
                  colorFieldName={"name"}
                  formatLabelFunction={formatLabelFunction}
                  loading={yearlyPaidAndPendingUnitsOfZone?.loading}
                  isNoData={!yearlyPaidAndPendingUnitsOfZone?.data?.length}
                />
              </Card>
            </Col>
          </Row>
          <Row className="second-row">
            <Col
              className="property-data-main-container"
              span={11}
              style={{ border: "1px solid black" }}
            >
              <div className="property-data-header-container">
                <Typography>Top Paid Units</Typography>
              </div>
              {topPaidUnitsOfZone?.loading ? (
                <div
                  style={{
                    width: "100%",
                    height: "30vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spin />
                </div>
              ) : topPaidProperties?.length === 0 ? (
                <div
                  style={{
                    width: "100%",
                    height: "30vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  No Properties to show.
                </div>
              ) : (
                <>
                  {topPaidProperties?.map((data, index) => {
                    return (
                      <div className="propeerty-data-container" key={index}>
                        <Typography>{data?.pin}</Typography>
                      </div>
                    );
                  })}
                </>
              )}
            </Col>
            <Col
              className="property-data-main-container"
              span={12}
              offset={1}
              style={{ border: "1px solid black" }}
            >
              <div className="property-data-header-container">
                <Typography>Top Pending Units</Typography>
              </div>
              {topDefaultUnitsOfZone?.loading ? (
                <div
                  style={{
                    width: "100%",
                    height: "30vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spin />
                </div>
              ) : topDefaultProperties?.length === 0 ? (
                <div
                  style={{
                    width: "100%",
                    height: "30vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  No Properties to show.
                </div>
              ) : (
                <>
                  {topDefaultProperties?.map((data, index) => {
                    return (
                      <div className="propeerty-data-container" key={index}>
                        <Typography>{data?.pin}</Typography>
                        <Typography className="pending-tax">
                          Pending PKR{" "}
                          {parseInt(data?.current_year_tax).toLocaleString()}
                        </Typography>
                      </div>
                    );
                  })}
                </>
              )}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  taxCollection: {
    yearlyTotalAndPaidTaxOfZone,
    yearlyPaidAndPendingUnitsOfZone,
    totalRegisteredPropertiesOfZone,
    taxOfZone,
    topPaidUnitsOfZone,
    topDefaultUnitsOfZone,
    circleOrZoneName,
  },
}) => ({
  yearlyTotalAndPaidTaxOfZone,
  yearlyPaidAndPendingUnitsOfZone,
  totalRegisteredPropertiesOfZone,
  taxOfZone,
  topPaidUnitsOfZone,
  topDefaultUnitsOfZone,
  circleOrZoneName,
});

const mapDispatchToProps = (dispatch) => ({
  getYearlyPaidAndTotalTaxOfZone: bindActionCreators(
    taxCollectionActions.getYearlyTotalAndPaidTaxOfZone,
    dispatch
  ),
  getYearlyPaidAndPendingUnitsOfZone: bindActionCreators(
    taxCollectionActions.getYearlyPaidAndPendingUnitsOfZone,
    dispatch
  ),
  getTotalRegisteredPropertiesOfZone: bindActionCreators(
    taxCollectionActions.getTotalRegisteredPropertiesOfZone,
    dispatch
  ),
  getTaxOfZone: bindActionCreators(taxCollectionActions.getTaxOfZone, dispatch),
  getTopPaidUnitsOfZone: bindActionCreators(
    taxCollectionActions.getTopPaidUnitsOfZone,
    dispatch
  ),
  getTopDefaultUnitsOfZone: bindActionCreators(
    taxCollectionActions.getTopDefaultUnitsOfZone,
    dispatch
  ),
  getCircleOrZoneName: bindActionCreators(
    taxCollectionActions.getCircleOrZoneName,
    dispatch
  ),
});

ZoneReportPDF.propTypes = {
  getYearlyPaidAndTotalTaxOfZone: PropTypes.func.isRequired,
  getYearlyPaidAndPendingUnitsOfZone: PropTypes.func.isRequired,
  getTotalRegisteredPropertiesOfZone: PropTypes.func.isRequired,
  getTaxOfZone: PropTypes.func.isRequired,
  getTopPaidUnitsOfZone: PropTypes.func.isRequired,
  getTopDefaultUnitsOfZone: PropTypes.func.isRequired,
  getCircleOrZoneName: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ZoneReportPDF);
